import React, { useContext, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { Dropdown } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useLocation } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import { NavigationList } from '../ResolveHeader/components/NavigationList';
import { getImgUrl } from 'components/ResolveImage/utils';

import './ProfileDropdown.styles.scss';

type ProfileDropdownProps = {
  className?: string;
};

const ProfileDropdown: React.FC<ProfileDropdownProps> = (props) => {
  const { className, children } = props;
  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();
  const { pathname } = useLocation();
  const {
    currentUser: { profileImage },
  } = useContext(CurrentUserContext);

  useEffect(() => {
    dropdown?.setIsOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const classes = classNames('profile-dropdown', className);

  const renderTrigger = useMemo(
    () => (
      <div className="profile-dropdown__trigger">
        <ResolveImage asAvatar src={getImgUrl(profileImage?.url, '100')} />
      </div>
    ),
    [profileImage],
  );

  return (
    <Dropdown
      closeWithJS
      renderAsPortal
      className={classes}
      trigger={renderTrigger}
      ref={dropdownRef}
    >
      <NavigationList onClose={() => dropdown?.setIsOpen(false)}>
        {children}
      </NavigationList>
    </Dropdown>
  );
};

export default ProfileDropdown;
